import React from "react"
import { Tabs as TabsBS } from "react-bootstrap"
import styled from "styled-components"
import { useLanguageState } from "../../globalStates/LanguageState"

interface TabsWrapperProps {
    color: string
}

const TabsWrapper = styled.div<TabsWrapperProps>`
    .nav-tabs {
        border: none;
        border-bottom: 1px solid #d9d9d9;
    }
    .nav-link {
        font-size: 18px;
        color: #727272;
        border: none;
    }
    .nav-link.active {
        font-weight: 700;
        color: ${(props) => props.color || "#6DD400"};
        border-bottom: 3px solid ${(props) => props.color || "#6DD400"};
    }
    .nav-link.invalid {
        color: #dc3545;
    }
`

interface TabsProps {
    children: React.ReactNode
}

const Tabs: React.FC<TabsProps> = ({ children }) => {
    const branding = useLanguageState().getStrings()
    return (
        <TabsWrapper color={branding.configuration.maincolor}>
            <TabsBS>{children}</TabsBS>
        </TabsWrapper>
    )
}

export default Tabs
